/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassAddResponse
 */
export interface ClassAddResponse {
    /**
     * The ID of the created class
     * @type {string}
     * @memberof ClassAddResponse
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassAddResponse interface.
 */
export function instanceOfClassAddResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassAddResponseFromJSON(json: any): ClassAddResponse {
    return ClassAddResponseFromJSONTyped(json, false);
}

export function ClassAddResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassAddResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
    };
}

export function ClassAddResponseToJSON(value?: ClassAddResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
    };
}

